// removed by extract-text-webpack-plugin
module.exports = {"editButton":"Ig8cD _1-OXK _3Xg8b _2QXSI _1FRJB _1DLUh","editButtonBody":"_1378v _1-OXK _3Xg8b _1Q5o6"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/EditButton.css
// module id = 777
// module chunks = 3